import { Typography } from "@mui/material";
var CalendarMonthHeader = function (_ref) {
    var label = _ref.label;
    return /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: "medium",
        color: "text.secondary"
    }, label);
};
export default CalendarMonthHeader;
